<template>
  <div class="language-setting">
    <el-select :value="lang" @change="updateLanguage">
      <el-option
          v-for="item in languageList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from "moment";
  export default {
    name: "Language",
    data: function () {
      return {
        languageList: [
          {
            label: '日本語',
            value: 'ja'
          },
          {
            label: 'Tiếng Việt',
            value: 'vn'
          },
          {
            label: 'English',
            value: 'en'
          }
        ]
      }
    },
    methods: {
      updateLanguage (lang) {
        this.$store.dispatch('login/updateLanguage', { lang })
      }
    },
    computed: {
      ...mapState('login', ['lang'])
    },
    mounted: function () {
      this.$i18n.locale = this.lang
      if(this.lang){
        let lang = this.lang
        if(this.lang==='vn'){
          lang = 'vi'
          moment.locale(lang)
        }else{
          moment.locale(this.lang)
        }
      }

    },
    watch: {
      lang: function () {
        this.$i18n.locale = this.lang
        if(this.lang){
          let lang = this.lang
          if(this.lang==='vn'){
            lang = 'vi'
            moment.locale(lang)
          }else{
            moment.locale(this.lang)
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .language-setting {
    width: 120px;
    position: absolute;
    right: 20px;
    top: 20px;
  }
</style>